import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {InstallationServiceModel} from "../models/view/installationServiceModel";
import {useState} from "react";
import {useInstallationContactGroupQuery} from "./useInstallationContactGroupQuery";

export const useInstallationServiceQuery = () => {
    const [open, setOpen] = useState<boolean>(false);
    const {model: {installationConsultation}} = useProductDetailsQuery();
    const {model} = useInstallationContactGroupQuery();
    return {
        model: new InstallationServiceModel(installationConsultation),
        contactGroupModel: {
            render: !!(model?.contactGroup?.email || model?.contactGroup?.phoneNumber),
            email: model?.contactGroup?.email,
            phone: model?.contactGroup?.phoneNumber
        },
        dropDownState: {
            open,
            toggle: () => setOpen(!open)
        }
    };
}